import React, {Component} from 'react';
import {Row, Breadcrumb, Table, Modal, Input} from 'antd';
import {Link} from 'react-router-dom';
import {api, app} from "../../app";
import utils from "../../utils";

const confirm = Modal.confirm;
const TextArea = Input.TextArea;

class MyFeedback extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data_loading: true,
            cancel_loading: false,
            problemList: [],
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            token: app.getData('token'),
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.dataSource();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 数据源
     */
    dataSource() {
        const _this = this, params = {
            indexno: this.state.indexno,
            account: this.state.account,
            token: this.state.token,
        };
        app.post(api.MyProblemsList, params).then(({flag, data, msg}) => {
            if (_this._isMounted) {
                if (flag === 1) {
                    _this.setState({problemList: utils.addArrayKey(data)});
                } else {
                    app.alert(msg, "warn");
                }
                _this.setState({data_loading: false});
            }
        });
    }

    handlCancelChange = (e) => {
        const {value} = e.target;
        this.setState({cancel_reason: value.trim()});
    }

    handleCancleProblem = (id) => {
        confirm({
            title: '取消问题',
            iconType: 'question-circle-o',
            okText: '确定',
            cancelText: '取消',
            maskClosable: true,
            confirmLoading: this.state.cancel_loading,
            width: '40%',
            onOk: () => {
                const _this = this
                return new Promise((resolve, reject) => {
                    const cancel_reason = _this.state.cancel_reason;
                    if (!this.state.cancel_reason) {
                        app.alert("请输入取消原因~", "warn");
                        reject();
                    } else if (this.state.cancel_loading) {
                        reject();
                    } else {
                        _this.setState({cancel_loading: true});
                        const params = {
                            indexno: _this.state.indexno,
                            account: _this.state.account,
                            token: _this.state.token,
                            problems_id: id,
                            cancel_reason: cancel_reason
                        };
                        app.post(api.ProblemsCancel, params).then(({flag, data, msg}) => {
                            if (_this._isMounted) {
                                if (flag === 1) {
                                    app.alert("提交成功", "success");
                                } else {
                                    app.alert(msg, "warn");
                                }
                                _this.dataSource();
                                _this.setState({cancel_loading: false});
                                resolve();
                            }
                        });
                    }
                });
            },
            content: (
                <Row id="cancel_reason" type="flex">
                    <span className="title">取消原因</span>
                    <TextArea className="content" rows={4} onChange={(e) => this.handlCancelChange(e)} maxLength={200}>

                    </TextArea>
                </Row>
            )
        });
    }

    render() {
        const cloumns = [
                {
                    title: '反馈主题',
                    dataIndex: 'title',
                    key: 'title',
                    width: '50%'
                },
                {
                    title: '回复数',
                    dataIndex: 'count',
                    key: 'count',
                    width: '10%',
                    render() {
                        return 10;
                    }
                },
                {
                    title: '反馈人',
                    dataIndex: 'vname',
                    key: 'vname',
                    width: '15%'
                },
                {
                    title: '反馈时间',
                    dataIndex: 'create_time',
                    key: 'create_time',
                    width: '15%'
                },
                {
                    title: '操作',
                    dataIndex: '',
                    key: 'cz',
                    width: '10%',
                    render: (text, record) => {
                        if (record.is_cancel === '1') {
                            return (<span className="canc_problem c_p">已取消</span>);
                        } else {
                            return (
                                <span onClick={() => this.handleCancleProblem(record.id)}
                                      className="cancel_problem c_p">取消反馈问题</span>);
                        }
                    }
                }
            ], loading = this.state.data_loading,
            locale = {
                filterTitle: '筛选',
                filterConfirm: '确定',
                filterReset: '重置',
                emptyText: loading ? '正在加载中...' : '暂无人提出问题',
            }, problemList = this.state.problemList;
        return (
            <div id="feedback_content">
                <div className="top-title">我的反馈<span>My Feedback</span></div>
                <Breadcrumb separator=">" className="breadcrumb">
                    <Breadcrumb.Item><Link to="/">首页</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>我的反馈</Breadcrumb.Item>
                </Breadcrumb>
                <Row className="myproblem_list">
                    <Table size="middle" locale={locale} pagination={false} columns={cloumns} dataSource={problemList}
                           loading={loading}>
                    </Table>
                </Row>
            </div>
        );
    }
}

export default MyFeedback;



// WEBPACK FOOTER //
// ./src/routes/feedback/MyFeedback.jsx